var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.836 14.115v1.718h4.167V17.5h-10v-1.667h4.166v-1.718A6.668 6.668 0 013.336 7.5v-5h13.333v5a6.668 6.668 0 01-5.833 6.615zm-10-9.948h1.667V7.5H.836V4.167zm16.667 0h1.666V7.5h-1.666V4.167z",
    fill: "#5C5C8E"
  })));
}
export default __webpack_public_path__ + "static/svg/trophy.svg";
export { SvgTrophy as ReactComponent };